"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var DropSilhouette = function DropSilhouette(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 383.344 383.345'
  }, props), /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M273.217,106.899c-27.181-44.864-57.413-83.693-73.016-102.846c-2.088-2.565-5.221-4.054-8.528-4.053\r c-3.308,0-6.44,1.489-8.529,4.054c-15.602,19.159-45.834,58.001-73.015,102.869c-35.028,57.823-52.789,105.63-52.789,142.09\r c0,74.071,60.261,134.332,134.332,134.332s134.332-60.261,134.332-134.332C326.005,212.529,308.246,164.715,273.217,106.899z\r M210.106,333.868c-7.844,2.006-15.986,3.022-24.205,3.022c-50.186,0-91.015-37.929-91.015-84.55\r c0-11.255,2.97-24.405,8.825-39.083c0.989-2.48,3.807-3.895,6.585-3.295c2.776,0.598,4.64,3.018,4.354,5.65\r c-0.342,3.148-0.516,6.223-0.516,9.136c0,50.735,40.881,93.221,95.093,98.821c2.698,0.279,4.803,2.297,5.018,4.812\r C214.461,330.896,212.723,333.198,210.106,333.868z'
  })));
};
/* eslint-enable */
var _default = DropSilhouette;
exports["default"] = _default;